/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const IconOk = ({ color = "black", className }) => {
  return (
    <svg
      className={`icon-ok ${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M6.66656 10.3907L4.47123 8.19533L3.52856 9.138L6.66656 12.276L13.1379 5.80467L12.1952 4.862L6.66656 10.3907Z"
        fill={color}
      />
    </svg>
  );
};

IconOk.propTypes = {
  color: PropTypes.string,
};
